window.addEventListener('load', function() {

    // Define a mapping of product names to desired outputs
    const productMappings = {
        "Sauna Backrests": "Select Backrest Wood Type",
        "Sauna Cushion": "Select Sauna Cushion Type",
        "Sauna Cushion Cover": "Select Cushion Cover Type",
        // ... add other product:replacement pairs as needed
    };

    // Get all the product containers
    const productContainers = document.querySelectorAll('#rbr-container-element-true .rbr-sbap_item');

    productContainers.forEach(container => {
        // For each container, find the product name and the select dropdown
        const productNameElement = container.querySelector('.rbr-productNamePrice__title__container a');
        const selectElement = container.querySelector('select');

        if (productNameElement && selectElement) {
            let productName = productNameElement.textContent.trim();
            
            // If product is found in mappings, use its replacement, otherwise default to "Select Package Products"
            let finalReplacementWord = productMappings.hasOwnProperty(productName) ? productMappings[productName] : "Select Package Products";

            // Replace "Select Variant" with the decided replacement word within this specific dropdown
            const options = selectElement.options;
            for (let i = 0; i < options.length; i++) {
                if (options[i].text === "Select Variant") {
                    options[i].text = finalReplacementWord;
                }
            }
        }
    });

});


 /* 
  window.addEventListener('load', function() {
  function replaceWords(originalWord, replacementWord) {
    const walk = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    let node;
    while (node = walk.nextNode()) {
      if (node.nodeValue.includes(originalWord)) {
        node.nodeValue = node.nodeValue.replace(new RegExp(originalWord, 'g'), replacementWord);
      }
    }
  }

  replaceWords('Select Variant', 'Select Package Products');
});

window.addEventListener('load', function() {
  function replaceWords(originalWord) {
    // Grab the product name from the page.
    const productNameElement = document.querySelector('.rbr-productNamePrice__title__container a');
    let productName = productNameElement ? productNameElement.textContent.trim() : null;

    let replacementWord;

    // Decide the replacement based on the product name.
    if (productName === "Sauna Backrests") {
      replacementWord = "Sauna Backrest Wood Type";
    } else {
      // Default replacement or other conditions can be added here
      replacementWord = "Select Package Products";
    }

    const walk = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    let node;
    while (node = walk.nextNode()) {
      if (node.nodeValue.includes(originalWord)) {
        node.nodeValue = node.nodeValue.replace(new RegExp(originalWord, 'g'), replacementWord);
      }
    }
  }

  replaceWords('Select Variant');
});
*/